
export default function getValidHref(value: string, type: string) {
  switch (type) {
    case 'email':
      return `mailto:${value}`;
    case 'call':
      return `tel:${value}`;
    default:
      return value;
  }
}
